<dashboard-dialog-frame icon='fa-solid fa-location-arrow' header='Venues' [actions]='actions' [dialogRef]='dialogRef'>
	<div class="venue-dialog p-2">
		<div class='venue-toolbar'>
			@if(!adding()){
			<div class="d-flex flex-row gap-1 align-items-center">
				<input style='width: 80px;display: inline-flex;' type="text" placeholder='Zip Code' [attr.maxLength]="5"
					[ngModel]="zip()?.code" (ngModelChange)="onZipInput($event)">
				@if(zip();as zip){
				<div style="vertical-align: text-top;padding-left: .5em;">{{zip.cityAndState}}</div>
				}
			</div>
			@if(invalidZip){
			<div class='venue-dialog-part-invalid-zip'>Please enter a valid zip code</div>
			}

			<button class="btn" (click)="setAdding()">
				<icon-text [iconContext]="addIconContext()"></icon-text>
			</button>
			}
		</div>

		@if(!adding()){
		@if(zip(); as zip){
		<choose-venue-part [zip]='zip' [venueInitialChoice]='venue()' (selection)='onVenueSelection($event)'>
		</choose-venue-part>
		}
		@else {
		<div class=' text-center mt-4 text-muted'>
			Please enter a valid U.S. zip code in the field above.
		</div>
		}
		}
		@else {
		<venue-add-part (addressSelected)='addAddress($event)'></venue-add-part>
		}
	</div>
</dashboard-dialog-frame>